import React from 'react';
import { grantedCount } from './permissionModel';

export default function PermissionRail({ areas, selected, query, onQuery, onJump }) {
  return (
    <aside className="re-rail">
      <input
        type="search"
        className="search-input re-search"
        placeholder="Search permissions"
        aria-label="Search permissions"
        value={query}
        onChange={(e) => onQuery(e.target.value)}
      />
      <nav aria-label="Permission areas">
        <ul className="re-rail-list">
          {areas.map((a) => (
            <li key={a.key}>
              <button type="button" className="re-rail-item" onClick={() => onJump(a.key)}>
                <span>{a.label}</span>
                <span className="re-rail-count">{`${grantedCount(a, selected)}/${a.permissions.length}`}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
}
